import ApiClient from "./client";
export * from "./errors";
export { BookingTypes } from "../warehouse/client/models";

const client = new ApiClient();
export default client;
